import { ChatPreferencesComponent } from "../../../../features/ai/chat-gpt/components/chat-preferences/chat-preferences.component";
import { IUserSettingsTab } from "../../models";
import { UserService } from "../../services";
import { GeneralSettingsComponent } from "../general-settings/general-settings.component";

const items: IUserSettingsTab[] = [
  {
    title: "General", selected: true, component: GeneralSettingsComponent
  },
  {
    title: "ISG GPT", selected: false, component: ChatPreferencesComponent
  },
];

export function initSettingsTabs(userService: UserService) {
  const items: IUserSettingsTab[] = [
    {
      title: "General", selected: true, component: GeneralSettingsComponent
    },
    //{
    //  title: "ISG GPT", selected: false, component: ChatPreferencesComponent
    //},
  ];

  return () => userService.registerSettingsTabs(items);
}
